export default __webpack_public_path__ + "static/media/icon-insights-phone-ordering.1ea29709.svg";